import api from './api';

const getGlossary = payload => api.get('/api/glossary/terms/', { params: payload });

export default {
  getGlossary,
};
